import * as categories from '../categories';
import { STRICTLY_NECESSARY, FUNCTIONAL, PERFORMANCE, TARGETING, ADVERTISING, SOCIAL } from '../constants';

const dict = {
	'all': [STRICTLY_NECESSARY, FUNCTIONAL, PERFORMANCE, TARGETING, ADVERTISING, SOCIAL],
	'tag manager': STRICTLY_NECESSARY,
	'website optimization': PERFORMANCE,
	'business intelligence': PERFORMANCE,
	'optimizer': PERFORMANCE,
	'video': PERFORMANCE,
	'publisher': PERFORMANCE,
	'agency': PERFORMANCE,
	'mobile': PERFORMANCE,
	'data aggregator/supplier': FUNCTIONAL,
	'content management/saas': FUNCTIONAL,
	'online privacy platform': FUNCTIONAL,
	'advertisers': TARGETING,
	'marketing solutions': TARGETING,
	'demand side platform': TARGETING,
	'data management platform': TARGETING,
	'supply side platform': TARGETING,
	'social media': TARGETING,
	'retargeter': TARGETING,
	'research provider': TARGETING,
	'analytics provider': TARGETING,
	'creative/ad format technology': TARGETING,
	'other': TARGETING
};

export const set = (cats) => {
	cats = Array.isArray(cats) ? cats : Object.entries(cats).map(([name, enabled]) => enabled && name).filter(e => e);
	const newCats = cats.flatMap(id => dict[id]).filter(a => !!a);
	categories.set(newCats);
};
